@if (processRecord.transitionsList?.length) {
  <div class="common-lateral-panel"
    [ngClass]="{'common-lateral-panel--expand':processRecord.fullScreen}">
    <div class="common-section-title__lp-container">
      <div class="common-section-title__lp-title-icon">
        <i class="lf-icon-track common-icon__lg"></i>
        <span class="common-section-title__lp-label-text"
          [afTranslate]="'process.summary.history-title'">_Histórico</span>
      </div>
    </div>
    <div class="common-lateral-panel__body">
      <div class="common-lateral-panel__list-items-gap">
        @for (transition of processRecord.transitionsList | afOrderBy: ['transitionDate']:false ; track $index) {
          <div class="common-stepper__history-container-stepper">
            <div class="common-stepper__history-dot-container">
              <div class="common-badge__block-dot-md">
                <div class="common-badge__dot-xs-main-1000"></div>
              </div>
              <div class="common-divider__vertical-main-400 h-[22px]"></div>
            </div>
            <div class="common-stepper__history-item-container">
              <div class="common-stepper__history-author-tag">
                <span class="common-stepper__history-author-text">{{transition.stateName}}</span>
              </div>
              <div class="common-stepper__history-date-container">
                <span class="common-stepper__history-date-text">{{transition.transitionDate | convertDate:'without-time'}}</span>
                <span class="common-stepper__history-date-text">{{transition.transitionDate | convertDate:'only-time'}}h</span>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    @if(processRecord.fullScreen || processRecord.transitionsList?.length > 3){
      <div class="common-lateral-panel__expand-block-right">
        <button class="common-button__expand-toned"
          (click)="processRecord.fullScreen = !processRecord.fullScreen">
          <i class=" common-icon__md"
            [ngClass]="processRecord.fullScreen? 'lf-icon-angle-up': 'lf-icon-angle-down'"></i>
          <span class="common-button__expand-label-text"
            [afTranslate]="processRecord.fullScreen?'common.collapse':'common.expand'"></span>
        </button>
      </div>
    }
  </div>
}
